/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Marked_WonInputs */

const cs_deals_marked_won = /** @type {(inputs: Deals_Marked_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod označen jako vyhraný`)
};

const en_deals_marked_won = /** @type {(inputs: Deals_Marked_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal marked as won`)
};

/**
* | output |
* | --- |
* | "Deal marked as won" |
*
* @param {Deals_Marked_WonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_marked_won = /** @type {((inputs?: Deals_Marked_WonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Marked_WonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_marked_won(inputs)
	return cs_deals_marked_won(inputs)
});